import React, { useState } from 'react';
import './TipButton.css';

const TipButton = ({ content, language = 'zh' }) => {
  const [showTip, setShowTip] = useState(false);

  return (
    <>
      {/* 提示按钮 */}
      <button 
        className="tip-button"
        onClick={() => setShowTip(true)}
        aria-label={language === 'en' ? 'View Tips' : '查看提示'}
      >
        <span className="tip-icon">💡</span>
        <span className="tip-text">{language === 'en' ? 'Tips' : '提示'}</span>
      </button>

      {/* 提示弹窗 */}
      {showTip && (
        <div className="tip-modal-overlay" onClick={() => setShowTip(false)}>
          <div className="tip-modal" onClick={(e) => e.stopPropagation()}>
            <button 
              className="tip-modal-close" 
              onClick={() => setShowTip(false)}
              aria-label={language === 'en' ? 'Close' : '关闭'}
            >
              &times;
            </button>
            <div className="tip-modal-icon">💡</div>
            <h3 className="tip-modal-title">
              {language === 'en' ? 'Practice Tips' : '练习提示'}
            </h3>
            <div className="tip-modal-content">
              {typeof content === 'string' ? (
                <p dangerouslySetInnerHTML={{ __html: content }} />
              ) : (
                content
              )}
            </div>
            <button 
              className="tip-modal-button" 
              onClick={() => setShowTip(false)}
            >
              {language === 'en' ? 'Got it' : '知道了'}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default TipButton;

